<template>
  <div class="villa-management">
    <!-- 搜索条件 -->
    <div class="search-container">
      <el-form :model="searchForm" label-width="100px" inline>
        <el-form-item label="别墅名称：">
          <el-input v-model="searchForm.name" placeholder="请输入别墅名称" />
        </el-form-item>
        <el-form-item label="别墅类型：">
          <el-select v-model="searchForm.type" placeholder="请选择别墅类型" clearable class="select-width">
            <el-option v-for="item in houseTypes" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item label="风格：">
          <el-select v-model="searchForm.style" placeholder="请选择风格" clearable  class="select-width">
            <el-option v-for="item in styles" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item label="状态：">
          <el-select class="status-width" v-model="searchForm.status" placeholder="请选择状态" clearable>
            <el-option label="有效" value="1" />
            <el-option label="无效" value="0" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button class="search_button" @click="handleSearch">搜索</el-button>
          <el-button class="button" @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 添加按钮 -->
    <div class="toolbar">
      <el-button class="search_button" @click="handleAdd">添加别墅</el-button>
    </div>

    <!-- 数据表格 -->
    <div class="table-container">
      <el-table :data="tableData" style="width: 100%" :header-cell-style="{ color: '#333', fontWeight: 'bold', fontsize: '14px' }">
        <el-table-column prop="houseName" label="别墅名称" min-width="100" >
          <template #default="scope">
            <span style="font-size: 12px;">{{ scope.row.houseName }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="houseType" label="别墅类型" min-width="60">
          <template #default="scope">
            <span style="font-size: 12px;">{{ getHouseTypeLabel(scope.row.houseType) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="style" label="风格" min-width="100">
          <template #default="scope">
            <el-tag v-for="onestyle in parseStyles(scope.row.style)" :key="onestyle" style="margin-right: 5px">
              {{ getStyleLabel(Number(onestyle)) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="houseImageUrl" label="图片" min-width="60">
          <template #default="scope">
            <el-image :src="scope.row.houseImageUrl" :preview-src-list="[scope.row.houseImageUrl]" preview-teleported
              style="width: 50px; height: 50px; cursor: pointer" fit="cover" />
          </template>
        </el-table-column>
        <el-table-column prop="workingDrawingPdf" label="施工图" min-width="60">
          <template #default="scope">
            <el-link v-if="scope.row.workingDrawingPdf" :href="scope.row.workingDrawingPdf" target="_blank" type="primary">
              查看施工图
            </el-link>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态" min-width="40">
          <template #default="scope">
            <el-tag :type="scope.row.status === '1' ? 'success' : 'danger'">
              {{ scope.row.status === '1' ? '启用' : '禁用' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" >
          <template #default="scope">
            <span style="font-size: 12px;">{{ formatDateTime(scope.row.createTime) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="250">
          <template #default="scope">
            <el-button size="small" @click="handleView(scope.row)" class="ope-button">查看详情</el-button>
            <el-button size="small" @click="handleEdit(scope.row)" class="ope-button">修改</el-button>
            <el-button size="small" @click="handleHouseStatus(scope.row)" class="ope-button">{{ scope.row.status === '0' ? '上架' : '下架' }}</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pagination-container">
        <el-config-provider :locale="zhCn">
          <el-pagination v-model:current-page="pagination.currentPage" v-model:page-size="pagination.pageSize"
            :page-sizes="[10, 20, 50, 100]" :total="pagination.total" layout="total, sizes, prev, pager, next, jumper"
            @size-change="handleSizeChange" @current-change="handleCurrentChange" />
        </el-config-provider>
      </div>
    </div>

    <!-- 图片预览对话框 -->
    <el-dialog v-model="imagePreview.visible" title="图片预览" width="600px">
      <el-image :src="imagePreview.url" :preview-src-list="[imagePreview.url]" preview-teleported style="width: 100%" />
    </el-dialog>
  </div>
</template>
<script>
  export default {
    name: 'HouseManage'
  }
</script>

<script setup>
import { ref, reactive, onMounted,getCurrentInstance } from 'vue'
import { useRouter } from 'vue-router'
import { ElMessage,ElMessageBox } from "element-plus";
import zhCn from 'element-plus/es/locale/lang/zh-cn'

// 路由实例
const router = useRouter()
const { proxy } = getCurrentInstance();

// 搜索表单数据
const searchForm = reactive({
  name: '',
  type: '',
  style: '',
  status: ''
})

// 别墅类型选项
const houseTypes = [
  { value: '1', label: '一层别墅' },
  { value: '2', label: '二层别墅' },
  { value: '3', label: '三层别墅' },
  { value: '4', label: '双拼别墅' },
  { value: '5', label: '火爆户型' },
  { value: '6', label: '本月新增' },
]

// 风格选项
const styles = [
  { value: 1, label: '中式' },
  { value: 2, label: '新中式' },
  { value: 3, label: '合院' },
  { value: 4, label: '简欧风' },
  { value: 5, label: '现代风' }
]

// 表格数据
const tableData = ref([])

// 分页数据
const pagination = reactive({
  currentPage: 1,
  pageSize: 10,
  total: 0
})

// 图片预览
const imagePreview = reactive({
  visible: false,
  url: ''
})

// 获取别墅类型标签
const getHouseTypeLabel = (type) => {
  const item = houseTypes.find(item => item.value === type)
  return item ? item.label : ''
}

// 解析逗号分隔的styles字符串
const parseStyles = (stylesStr) => {
  if (!stylesStr) return []
  return stylesStr.split(',').filter(style => style.trim() !== '')
}

// 获取风格标签
const getStyleLabel = (style) => {
  const item = styles.find(item => item.value === style)
  return item ? item.label : ''
}

// 处理搜索
const handleSearch = () => {
  fetchData()
}

// 重置搜索
const handleReset = () => {
  searchForm.name = ''
  searchForm.type = ''
  searchForm.style = ''
  searchForm.status = ''
  fetchData()
}

// 添加别墅
const handleAdd = () => {
  router.push('/houseCart/addHouse');
}

// 查看详情
const handleView = (row) => {
  const houseId = row.houseId;
  const houseName = row.houseName;
  const houseType = getValueLabel(row.houseType);
  const path = '/houseCart/houseDetailManage';
  router.push({ 
    path, 
    query: { houseId:houseId,houseName:houseName,houseType:houseType } 
  });
}

const getValueLabel = (value) => {
  const item = houseTypes.find(item => item.value === value)
  return item ? item.label : ''
}


// 修改
const handleEdit = (row) => {
  const encodedData = encodeURIComponent(JSON.stringify(row))
  router.push({
    path: '/houseCart/updHouse',
    query: {
      mode: 'edit',
      data: encodedData
    }
  })
}

// 处理分页大小变化
const handleSizeChange = (val) => {
  pagination.pageSize = val
  fetchData()
}

// 处理当前页变化
const handleCurrentChange = (val) => {
  pagination.currentPage = val
  fetchData()
}

// 获取数据
const fetchData = () => {
  let url = "/house/imQueryHouse";
  proxy.$tools.request(url,
    {
      reqBody: {
        houseName: searchForm.name,
        houseType: searchForm.type,
        style: searchForm.style,
        status: searchForm.status,
        pageNo: pagination.currentPage,
        pageSize: pagination.pageSize
      }
    }
  ).then(response => {
    const code = response.data.rspHead.returnCode;
    if (code === '00000000') {
      tableData.value = response.data.rspBody.houseList;
      pagination.total = response.data.rspBody.total;
      console.log(response.data.rspBody.houseList);
    } else {
      ElMessage.error('系统异常，请联系管理员' + response.data.rspHead.returnMsg);
    }
  }).catch(error => {
    // 处理错误情况
    ElMessage.error('系统异常，请联系管理员' + error);
  });

}

// 启动或者禁用别墅
const handleHouseStatus = (row) => {
const newStatus = row.status === '1' ? '0' : '1'
  const statusName = newStatus === '1' ? '上架' : '下架'

  ElMessageBox.confirm(
    `确定要${statusName}别墅 "${row.houseName}" 吗？`,
    '提示',
    {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }
  ).then(() => {
    // 模拟API调用
    let url = '/house/updateHouse';
    proxy.$tools.request(url,
      { reqBody: { houseId: row.houseId, status: newStatus } }
    ).then(response => {
      const code = response.data.rspHead.returnCode;
      if (code === '00000000') {
        ElMessage.success('操作成功');
        fetchData();
      } else {
        ElMessage.error('系统异常，请联系管理员' + response.data.rspHead.returnMsg);
      }
    }).catch(error => {
      // 处理错误情况
      ElMessage.error('系统异常，请联系管理员' + error);
    });
  }).catch(() => {
    // 取消操作的逻辑（可选）
    // 这里可以留空或者添加取消后的处理逻辑
  })
}

const formatDateTime = (dateString) => {
  const date = new Date(dateString)
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  const hours = String(date.getHours()).padStart(2, '0')
  const minutes = String(date.getMinutes()).padStart(2, '0')
  const seconds = String(date.getSeconds()).padStart(2, '0')

  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
}

// 组件挂载时获取数据
onMounted(() => {
  fetchData()
})
</script>

<style scoped>
.villa-management {
  padding: 20px;
}

.search-container {
  padding: 20px;
  border-radius: 4px;
  /* margin-bottom: 20px; */
}
.status-width {
  width: 120px;
}
.select-width {
  width: 150px;
}

.search_button {
  background-color: #2b82cf;
  width: 100px;
  height: 35px;
  border: 1px solid #2b82cf;
  border-radius: 4px;
  font-size: 14px;
  color: #fff;
}

.search_button:hover {
  background-color: #409eff;
  color: #fff;
}

.button {
  width: 100px;
  height: 35px;
  border: 1px solid #2b82cf;
  border-radius: 4px;
  font-size: 14px;
  color: #2b82cf;
}
.ope-button{
  width: 60px;
  height: 30px;
  border: 1px solid #2b82cf;
  border-radius: 4px;
  font-size: 13px;
  color: #2b82cf;
}
.toolbar {
  margin-bottom: 20px;
  text-align: left;
}

.table-container {
  padding: 20px;
  border-radius: 4px;
}

.pagination-container {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
}

.pagination-container :deep(.el-pagination) {
  font-size: 13px;
  font-weight: 400;
}

.pagination-container :deep(.el-pagination .el-pager li) {
  font-size: 13px;
  min-width: 30px;
  height: 30px;
  line-height: 30px;
}

.pagination-container :deep(.el-pagination .el-pagination__total) {
  font-size: 13px;
  color: #666;
}

.pagination-container :deep(.el-pagination .el-pagination__jump) {
  font-size: 13px;
  color: #666;
}

.pagination-container :deep(.el-pagination .el-input__inner) {
  font-size: 14px;
  height: 25px;
}

.pagination-container :deep(.el-pagination button) {
  font-size: 14px;
  min-width: 30px;
  height: 30px;
  padding: 0 8px;
}

.pagination-container :deep(.el-pagination .el-select) {
  font-size: 10px;
  width: 100px;
  margin: 0 10px;
}
</style>
